var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3AB5E8;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.8,15.1L72.8,15.1L72.8,15.1c-1.4-1.3-3.1-2-5-2H7.2c-1.8,0-3.5,0.7-4.9,1.9l0,0l0,0C0.8,16.4,0,18.3,0,20.3 v34.8c0,2.2,1,4.2,2.7,5.6c1.3,1.1,2.9,1.6,4.6,1.6h60.5c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.4,0c1.5-0.1,2.9-0.8,4.1-1.8l0,0 c1.6-1.4,2.5-3.4,2.5-5.5V20.3c0-2-0.8-3.8-2.2-5.2L72.8,15.1z M46.1,40.7l25.5-22.3c0.3,0.6,0.5,1.2,0.5,1.9v34.8 c0,0.9-0.3,1.7-0.7,2.4L46.2,40.7H46.1z M67.8,16c0.5,0,1.1,0.1,1.6,0.3l-30,26.3c-0.9,0.8-2.4,0.8-3.3,0L5.9,16.3 c0.4-0.1,0.9-0.2,1.4-0.2L67.8,16L67.8,16z M3,55.1V20.3c0-0.7,0.2-1.5,0.6-2.1l25.7,22.5L3.8,57.6C3.3,56.9,3,56,3,55.1z M7.2,59.3 c0,0-0.2,0-0.3,0l0,0H6.7l0,0l24.9-16.6l2.4,2.1c1,0.9,2.3,1.4,3.6,1.4s2.6-0.5,3.6-1.4l2.4-2.1l24.9,16.5l0,0c0,0,0,0-0.1,0l0,0 c0,0,0,0-0.1,0l0,0c0,0,0,0-0.1,0l0,0c0,0-0.1,0-0.2,0H7.2V59.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4cd62e147bbbdcd25a254e6202774324.svg";
export { ForwardRef as ReactComponent };